import { useEffect, useMemo, useState } from "react";
import "./AdminUpdatesPopup.css";

const UPDATES_BY_ROLE = {
  ADMIN: {
    version: "2026-03-11-admin-01",
    title: "Ultimas atualizacoes (Admin)",
    publishedAt: "11/03/2026",
    informedUsers: ["Administradores"],
    items: [
      "Ajustado datas de saque",
    ],
  },
  LICENSED: {
    version: "2026-03-11-licensed-01",
    title: "Ultimas atualizacoes",
    publishedAt: "11/03/2026",
    informedUsers: ["Licenciados"],
    items: [
      "Agora voce recebe e-mail de confirmacao ao solicitar saque",
      "Notificacao de atualizações",
      "Sugestões disponíveis em ajuda",
    ],
  },
};

function getSeenKey(user, role) {
  const userKey = user?.id || user?.email || "admin";
  return `admin_updates_seen:${String(userKey)}:${String(role || "UNKNOWN")}`;
}

const AdminUpdatesPopup = ({ user, role }) => {
  const [open, setOpen] = useState(false);

  const normalizedRole = String(role || user?.access_type || "").toUpperCase();
  const updateData = UPDATES_BY_ROLE[normalizedRole] || null;

  const storageKey = useMemo(
    () => getSeenKey(user, normalizedRole),
    [user, normalizedRole]
  );

  const informedUsersLabel = useMemo(() => {
    if (!updateData) return "Nao informado";

    if (Array.isArray(updateData.informedUsers)) {
      const list = updateData.informedUsers
        .map((item) => String(item || "").trim())
        .filter(Boolean);
      return list.length ? list.join(", ") : "Nao informado";
    }

    const value = String(updateData.informedUsers || "").trim();
    return value || "Nao informado";
  }, [updateData]);

  useEffect(() => {
    if (!updateData) {
      setOpen(false);
      return;
    }

    try {
      const lastSeenVersion = localStorage.getItem(storageKey);
      if (lastSeenVersion !== updateData.version) {
        setOpen(true);
      }
    } catch (_err) {
      setOpen(true);
    }
  }, [storageKey, updateData]);

  const fechar = () => {
    if (!updateData) {
      setOpen(false);
      return;
    }

    try {
      localStorage.setItem(storageKey, updateData.version);
    } catch (_err) {
      // sem bloqueio se localStorage estiver indisponivel
    }
    setOpen(false);
  };

  if (!updateData) return null;
  if (!open) return null;

  return (
    <div className="admin-updates-backdrop" onMouseDown={fechar}>
      <div className="admin-updates-modal" onMouseDown={(e) => e.stopPropagation()}>
        <div className="admin-updates-header">
          <div>
            <h3>{updateData.title}</h3>
            <p>Publicacao: {updateData.publishedAt}</p>
            <p className="admin-updates-users">Usuarios informados: {informedUsersLabel}</p>
          </div>
          <button
            type="button"
            className="admin-updates-close"
            onClick={fechar}
            aria-label="Fechar atualizacoes"
          >
            x
          </button>
        </div>

        <ul className="admin-updates-list">
          {updateData.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>

        <div className="admin-updates-actions">
          <button type="button" className="admin-updates-ok" onClick={fechar}>
            Entendi
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminUpdatesPopup;
